import { Component, OnInit, Input, Injectable, Inject, ViewChild } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { SecurityService } from '../security.service';

import 'rxjs/add/operator/toPromise';
import { PaginatorComponent } from '../../shared-components/paginator/paginator.component';
import { EnvironmentProvider } from '../../core/browser-providers';
import { Permission } from './permission.model';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { TranslateService } from '../../core/translate.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';

const DECIMAL_FORMAT: (v: any) => any = (v: number) => v.toFixed(2);

interface Filters {
  name: string;
  page: number;
  size: number;
  email?: string;
  search?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss']
})
export class PermissionComponent implements OnInit {

  private backendUrl: string;

  private filters: Filters = {
    name: undefined,
    page: 0,
    size: 10,
  };

  @ViewChild(PaginatorComponent)
  private paginatorComponent: PaginatorComponent;

  @ViewChild(SearchInputComponent)
  private permissionSearchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public showFilters = true;
  public totalItems: number;

  permissionFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  permissionList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Permission, Permission.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.permissionFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Permission[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    protected updateEventService: UpdateEventService,
    private http: Http,
  ) {
    this.backendUrl = env.endpoints.api+'/backend';
  }

  ngOnInit() {
    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.permissionList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshPermissionList();
  }


  refreshPermissionList() {
    this.permissionList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      name : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshPermissionList();
  }

  onSearch(searchText) {
    this.filters.search = 'name:' + searchText;
    this.refreshPermissionList();
  }

  clearSearch() {
      this.permissionSearchComponent.searchBox.value = '';
      this.refreshPermissionList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

}



// WEBPACK FOOTER //
// ./src/app/security/permission/permission.component.ts